<template>
  <div class="results container"  :class="{'iphone': iOS}">      
    <FootnoteDisplay></FootnoteDisplay>      
  </div>
</template>

<script>
import FootnoteDisplay from "../components/FootnoteDisplay"

export default {
  name: 'Results',
  components: { 
    FootnoteDisplay
  },
  data() {
    return {
      iOS: false
    }
  },  
  props: {
    
  },
  mounted: function() {
    document.body.classList.remove("search-focused")
    this.iOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
  },
  computed: {   
    hebrew () {
      return this.$settings.hebrew
    }    
  }
}
</script>
<style>
  .dicta-dropdown .col-auto {
    padding-left: 9px;
    padding-right: 9px;
  }
</style>
<style scoped lang="scss">
  .results{
    @media only screen and (max-width: 991px) {
      min-height: calc(100vh - 195px)
    } 
    &.iphone {
      @media only screen and (max-width: 991px) {
        min-height: calc(100vh - 201px)
      }    
    }     
   }
  .result-controls{
    direction: ltr;
  }
  .he .result-controls{
    direction: rtl;
  }
  @media only screen and (min-width: 992px) {
    .mode-dd{
      width:268px;
    }
    .he .mode-dd{
      width:234px;
    }
    .w-md-25{
      width:25%;
    }
    .w-md-75{
      width:75%;
    }
    .view-dd{
      width:185px;
      margin:0 40px;
      position: relative;
      &::before, &::after{
        content:'';
        height: 100%;
        position: absolute;
        width: 1px;
        background:#d8d8d8;
        left: -23px;
        top:0;
      }
      &::before{
        right:-17px;
        left: auto;
      }
    }
  }
  .accuracy-slider{
    width:335px;
    max-width: 100%;
  }
</style>